import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { JobsFilter } from '../../generated/graphql.generated';

@Component({
  selector: 'app-job-tab',
  template: `
    <app-jobs
      [filter]="filter"
      [tagNames]="tagNames"
      [showHeaderCard]="true"
      [syncToQueryParams]="false"
    ></app-jobs>
  `,
  standalone: false,
})
export class JobTabComponent implements OnInit {

  filter: JobsFilter = {};

  /** Tag names from the route's `tags` data key. See JobsComponent.tagNames. */
  tagNames: string | undefined;

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const search = this.route.snapshot.queryParamMap.get('search');
    this.filter = {
      ...this.route.snapshot.data['filter'],
      ...(search ? { search } : {}),
    };
    this.tagNames = this.route.snapshot.data['tags'];
  }
}
